module.exports = __webpack_public_path__ + "static/media/United_logo_white.30094449.png";